import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiTag,
    title: "Valutiamo il tuo usato",
    desc: "Il suo valore abbatte il costo dello sgombero."
  },
  {
    icon: FiIcons.FiTrash2,
    title: "Smaltimento a norma",
    desc: "Tutto conferito in discariche autorizzate."
  },
  {
    icon: FiIcons.FiZap,
    title: "Interventi Rapidi",
    desc: "Siamo operativi anche per urgenze."
  },
  {
    icon: FiIcons.FiShield,
    title: "Massima Professionalità",
    desc: "Preventivi chiari, zero costi nascosti."
  }
];

export default function Features() {
  return (
    <section className="py-20 bg-[#080808] border-y border-white/5">
      <div className="container mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, idx) => (
            <motion.div 
              key={idx}
              className="flex items-start gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <div className="mt-1">
                <SafeIcon icon={feature.icon} className="text-3xl text-maaich-lime" />
              </div>
              <div>
                <h4 className="font-display uppercase text-lg italic mb-1">{feature.title}</h4>
                <p className="text-sm text-white/50 font-body leading-relaxed">{feature.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}